// For environment details see: https://confluence.mtvi.com/display/TCP/Global+Entry+-+execution+environment+-+Level+1+-+development

export const version = '2024-11-26_556';
export const aspera_uid = '';
export const aspera_pwd = '';
